import FrontshopLink from './FrontshopLink';

export default FrontshopLink;
